import cn from 'classnames';

import {
  getFormattedLocalizedDateNoTime,
  getLocalizedTimeWithSeconds,
} from '$shared/utils/date.utils';

import './cell-timestamp.scss';

interface CellTimestampProps {
  timestamp: string | number | null | undefined;
  isResponsive?: boolean;
  className?: string;
}

export function CellTimestamp({
  isResponsive = false,
  timestamp,
  className,
}: CellTimestampProps) {
  const classNames = cn('cell-timestamp', className, {
    'cell-timestamp--is-responsive': isResponsive,
  });

  return (
    <div className={classNames}>
      <time className="cell-timestamp__date">
        {getFormattedLocalizedDateNoTime(timestamp ?? '', true)}
      </time>
      <time className="cell-timestamp__time">
        {getLocalizedTimeWithSeconds(timestamp ?? '', true)}
      </time>
    </div>
  );
}
